export function resolveInitialAdmissionTicketsEnabled(initialData = {}, attendanceMode = 'none') {
  const isExisting = Boolean(initialData.id || initialData.originalId);
  if (isExisting) return initialData.admissionTicketsEnabled === true;
  return attendanceMode === 'ticketed';
}
